<div class="w-full h-12rem px-4 flex align-items-center justify-content-center " style="margin: -32px 0 0 0; background: url(../../../../assets/images/header_bg1.png) no-repeat left top #000086; background-size: cover;">
  <h1 class="w-full text-center font-bold text-2xl lg:text-6xl sm:text-4xl md:text-5xl " style="color: #fff;">Profile Building Opportunities</h1>
</div>
<div class="container_width mt-5">

  <div class="w-full flex justify-content-end mb-3">
    <p-button 
      [label]="'Saved: ' + myScholarshipCount"
      icon="pi pi-bookmark"
      (onClick)="myScholarshipsOnly = !myScholarshipsOnly"
      [styleClass]="myScholarshipsOnly ? 'p-button-success' : 'p-button-outlined'">
    </p-button>
  </div>

  <div class="w-full mb-4 flex">
    <div class="w-full flex flex-column gap-3">
      <div class="w-full flex flex-column gap-2 py-4 bg-white">
        <h2 class=" font-medium text-2xl py-2" style="color: #303030;">Search</h2>
        <form [formGroup]="filterForm" (ngSubmit)="getScholarships()" class="w-full flex flex-wrap ">
          <div class="w-full grid">
            <div class="col-3 flex flex-column gap-1">
              <b class="font-regular text-base " style="color: #505050;">Name</b>
              <p-autoComplete formControlName= "scholarshipName" [suggestions]="schoplarshipNames" placeholder="Name"
                [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('scholarshipName')?.value}"
                class="w-full" (completeMethod)="filterScholarshipNames($event)" styleClass="fullWidth" [showClear]="true">
              </p-autoComplete>
            </div>
            <div class="col-3 flex flex-column gap-1">
              <b class="font-regular text-base " style="color: #505050;">Stream</b>
              <p-dropdown #streamDropdown [options]="streamOptions" styleClass="selectFull" class="w-full"
                   formControlName="stream" filterBy="name" [showClear]="true"
                  appendTo="body"
                  [panelStyle]="{'max-width': (streamDropdownWidth || 200) + 'px'}"
                  [style]="{'min-width': '120px'}"
                  placeholder="Select Stream">
                </p-dropdown>
            </div>
            <div class="col-3 flex flex-column gap-1">
              <b class="font-regular text-base " style="color: #505050;">Level</b>
              <p-dropdown [options]="levelOptions" styleClass="selectFull" class="w-full"
                   formControlName="level" filterBy="name" [showClear]="true"
                  appendTo="body"
                  [style]="{'min-width': '120px'}"
                  placeholder="Select Level">
                </p-dropdown>
            </div>
            <div class="col-3 flex align-items-end">
              <p-button type="submit" label="Search" class="w-full h-3rem" styleClass="submitBtn" />
            </div>

          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="w-full grid">
    <div *ngFor="let item of filteredScholarships; let i = index" class="col-12 sm:col-6 md:col-4">
      <div class="w-full h-full flex flex-column bg-white border-round-lg border-1" style="border-color: #D0D0DD;">
  
        <!-- Image Section -->
        <div class="relative w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden"
          style="background-color: #F6F8FF; aspect-ratio: 4 / 3; border-color: #D0D0DD;">
          <img *ngIf="item.image; else noImage" [src]="item.image" alt="" style="max-width: 80%; max-height: 80%; mix-blend-mode: multiply;">
<ng-template #noImage>
  <i class="pi pi-briefcase" style="font-size: 3.5rem; color: #9AA0B5;"></i>
</ng-template>
          <div class="w-auto flex align-items-center gap-2 absolute" style="top: 8px; right: 8px;">
            <input type="checkbox" 
            [disabled]="loadingScholarshipId === item.id"
            [checked]="item.isMyScholarship"
            (change)="toggleMyScholarship(item.id)" class="wishlist" >
            <span *ngIf="loadingScholarshipId === item.id">
              <i class="pi pi-spin pi-spinner"></i>
            </span>
            
        </div>
        </div>
  
        <!-- Content + Button -->
        <div class="w-full flex flex-column p-3" style="flex: 1;">
  
          <!-- Content Area -->
          <div class="flex flex-column gap-3" style="flex: 1;">
            <b class="w-full text-left font-bold text-lg pb_link">{{item.name}}</b>
            <b class="w-full text-left font-normal text-base" style="color: #515055;">Organisation: {{item.universityOrOrganisationName}}</b>
  

            <!-- Start Date
<div class="w-full flex flex-column">
  <b class="w-full text-left font-normal text-base" style="color: #515055;">Start Date</b>
  <div *ngFor="let startDate of item.startDate; let i = index" class="flex align-items-center gap-2 py-2">
    <img src="../../../../assets/icons/calendar_icon.svg" alt="" style="width: 22px;">
    <p class="text-left font-medium text-base" style="color: #212022;">{{startDate}}</p>
  </div>
</div> -->
  
            <!-- Deadline
            <div class="w-full flex flex-column">
              <b class="w-full text-left font-normal text-base" style="color: #515055;">Application Deadline</b>
              <div *ngIf="item.deadLine" class="flex align-items-center gap-2 py-2">
                <img src="../../../../assets/icons/calendar_icon.svg" alt="" style="width: 22px;">
                <p class="text-left font-medium text-base" style="color: #212022;">
                  {{item.deadLine.exactDate}} {{item.deadLine.exactDate && item.deadLine.month ? '-' : ''}} {{item.deadLine.month}}
                  <span *ngIf="!item.deadLine.exactDate && !item.deadLine.month">N/A</span>
                </p>
              </div>
            </div> -->

            <!-- Deadline -->
<div class="w-full flex flex-column">
  <b class="w-full text-left font-normal text-base" style="color: #515055;">Application Deadline</b>
  <div class="flex align-items-center gap-2 py-2">
    <img src="../../../../assets/icons/calendar_icon.svg" alt="" style="width: 22px;">
    <p class="text-left font-medium text-base" style="color: #212022;">{{ formatDeadline(item.deadLine) }}</p>
  </div>
</div>

          </div>
  
          <!-- Bottom Button -->
          <div class="w-full mt-3 flex justify-content-center">
            <a [routerLink]="['/portal/mentor-me']"
              class="w-full flex align-items-center justify-content-center gap-3 talktoMentor">
              <i class="pi pi-phone"></i>
              <span>Talk to a Mentor</span>
            </a>
          </div>
  
        </div>
      </div>
    </div>
  </div>
  
